export interface TagChipProps {
  label: string;
  variant?: 'specialty' | 'fee';
}

export function TagChip({ label, variant = 'specialty' }: TagChipProps) {
  const style =
    variant === 'specialty'
      ? 'bg-accent text-[var(--content-green-dark)]'
      : 'bg-muted text-foreground';

  return <span className={`rounded-full px-2.5 py-1 text-xs font-medium ${style}`}>{label}</span>;
}
